module.exports = __webpack_public_path__ + "static/media/solo9.4c69f1e5.JPG";